import { GoogleLoginSection } from '../google-login-section/google-login-section';

export type OauthSectionProps = {
  // Provider availability (mirror `useEnableGoogleLogin`). Only available providers render.
  enableGoogle: boolean;
  isGoogleLoading: boolean;
  onGoogleSignIn: () => void;
  disabled?: boolean;
  // Neutral wording lets the same section read correctly on login and sign-up.
  googleLabel?: string;
};

/**
 * Shared OAuth provider section rendered on BOTH the login and sign-up pages (spec 007, R1).
 * Today it exposes Google only; Facebook / Microsoft / Apple slots are added here once the
 * Firebase console has them enabled per environment (T025 — infra dependency). Keeping the
 * composition in one place avoids per-page duplication (Constitution VIII).
 */
export const OauthSection = ({
  enableGoogle,
  isGoogleLoading,
  onGoogleSignIn,
  disabled,
  googleLabel,
}: OauthSectionProps) => {
  if (!enableGoogle) {
    return null;
  }

  return (
    <GoogleLoginSection
      isLoading={isGoogleLoading}
      disabled={disabled}
      onSignIn={onGoogleSignIn}
      label={googleLabel}
    />
  );
};
